<template>
  <div class="customers full-page-width">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'ItemsIndex',
};
</script>
